module.exports = __webpack_public_path__ + "dcab198d69a9dcc2f0c04e7d6fc53dd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000016R5.png
// module id = 1656
// module chunks = 0